<template>
  <div>
    <div class="sky-env-relate-scene">
      <div v-for="(item, index) in dataArr" :key="index" class="sky-env-relate-scene__list">
        <div class="sky-env-relate-scene__item">
          <el-form-item prop="envData" ref="formItem" label="环境数据" class="sky-env-relate-scene__item-env">
            <sky-relation-option
              v-model="item.envData"
              multiple="true"
              :register-component-id="registerComponentId + _uid + '_envData_' + index"
              @click.native="handleRelationEnvData(index)"
            />
          </el-form-item>
          <el-form-item
            prop="scene"
            ref="formItem"
            label="关联场景"
            rules="dataArrRules"
            verify
            class="sky-env-relate-scene__item-scene"
          >
            <el-select v-model="item.scene" :disabled="disabled || loading" @change="handleChange">
              <el-option v-for="item in scenes" :key="item.id" :label="$t(item.label)" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <i
          class="sk-icon-remove sky-env-relate-scene__item-delete"
          v-if="dataArr.length > 1"
          @click="handleDelete(index)"
        ></i>
      </div>
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="sky-env-relate-scene__add"
        @click="handleAdd"
        :disabled="disabled || loading"
      >
        {{ $t('pocMng.addBind') }}
      </el-button>
    </div>
    <div class="download-item" style="right: -540px;">
      <div class="el-icon-download sk-link--normal" @click="downloadCollectTool()">环境采集工具下载</div>
      <div class="download-item-title font-size-10 font-weight-300" style="width: 480px;">
        通过不同用户使用场景，使用环境采集工具进行预先数据采集，并与对应的业务场景进行绑定，平台会根据采集数据进行推荐及计算服务器资源（支持Windows7/Windows10/Windows11）（客户环境采集工具，可点击上方连接进行下载）
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import RelationOption from 'sky-engine/views/formController/form/relation-option'

import { SCENE_MNG } from '@/api'
import { getCollectTool } from '@/utils/pageUtils'
export default {
  name: 'SkyEnvRelateScene',
  inject: ['elForm'],
  components: {
    [RelationOption.name]: RelationOption,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    industryId: {
      type: String,
      default: null
    }
  },
  data() {
    let dataArr = this.value
    if (!dataArr || !dataArr.length) {
      dataArr = [{ envData: null, scene: null }]
    }
    dataArr = [{ envData: null, scene: null }]
    this.$emit('input', dataArr)
    return {
      registerComponentId: 'envRelateScene',
      dataArr: dataArr,
      options: [],
      scenes: [],
      checkList: [],
      industry: null,
      loading: false
    }
  },
  watch: {
    value(value) {
      this.dataArr = value
    },
    industryId(value) {
      this.loading = true
      this.dataArr = [{ envData: null, scene: null }]

      action(SCENE_MNG, 'querySceneOptions', { industryId: value })
        .then(response => {
          this.options = response.data.content.itemArr.map(item => {
            return {
              id: item.id,
              label: item.sceneName
            }
          })
          this.scenes = this.options

          this.$nextTick(() => {
            this.elForm.clearValidate()
            this.loading = false
          })
        })
        .catch(e => {
          this.loading = false
          throw e
        })
    }
  },
  computed: {
    dataArrRules() {
      const validatorBranch = (rule, value, callback) => {
        this.checkList = []

        for (let i = 0; i < value.length; i++) {
          if (!value[i].envData || !value[i].scene) {
            this.checkList.push(i)
            callback(new Error(this.$t('moduleManage.branchEmpty')))
          }
        }
        if (!this.checkList.length) {
          callback()
        }
      }
      return ['notEmpty', [{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  mounted() {},
  methods: {
    downloadCollectTool() {
      getCollectTool()
    },
    handleRelationEnvData(index) {
      this.$store.dispatch('ShowCollectInfo', {
        formItemId: this.registerComponentId + this._uid + '_envData_' + index
      })
    },
    changeScene() {
      const sceneIds = this.dataArr
        .map(item => {
          if (item.scene != '' && item.scene !== undefined) {
            return item.scene
          }
        })
        .filter(scene => scene !== null && scene !== undefined)

      this.scenes = this.options.filter(item => {
        if (!sceneIds.includes(item.id)) {
          return item
        }
      })
    },
    handleAdd() {
      if (this.dataArr.length == this.options.length) {
        return
      }
      this.dataArr.push({ envData: '', scene: '' })
      this.$refs.formItem.validate('blur', errMsg => {
        if (!errMsg) {
          this.dataArr.push({ envData: '', scene: '' })
          this.$emit('input', this.dataArr)
          this.$refs.formItem.validate('blur')
        }
      })
    },
    handleDelete(index) {
      this.dataArr.splice(index, 1)
      this.changeScene()
      this.$emit('input', this.dataArr)
      // this.$refs.formItem.validate('blur')
    },
    handleChange(value) {
      this.changeScene()
      // elForm._data.fields[0].elForm.model.industryId
      this.$emit('input', this.dataArr)
    },
    isSucess(index) {
      return this.checkList.length && !this.checkList.includes(index)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
.download-item {
  position: absolute;
  top: 0;
  right: -158px;
  padding: 0.29167rem 0.625rem;
}
@include b(env-relate-scene) {
  margin-bottom: 2px !important;
  .download-item {
    position: absolute;
    top: 0;
    right: -540px;
    padding: 0.29167rem 0.625rem;
    .download-item-title {
      width: 480px;
    }
  }
  @include e(list) {
    display: flex;
    align-items: center;
    // margin-top: 20px;
  }
  @include e(item) {
    // display: flex;
    border: 2px solid #d9d9d9;
    margin-bottom: 10px;
    padding-top: 10px;
    width: 100%;
    // align-items: center;
    // justify-content: center;
  }
  @include e(item-env) {
    margin: 0 24px;
    width: 100%;
    & .el-form-item__label {
      width: 100px !important;
      text-align: left;
    }
    & .el-form-item__content {
      margin-left: 100px !important;
      width: 72%;
    }
  }
  @include e(item-scene) {
    margin: 0 24px;
    width: 100%;
    & .el-form-item__label {
      width: 100px !important;
      text-align: left;
    }
    & .el-form-item__content {
      margin-left: 100px !important;
      width: 72%;
    }
  }
  @include e(item-delete) {
    display: inline-block;
  }
  @include e(branch) {
    width: 255px !important;
    border-left: 0;
    & .el-input__inner {
      border-left: 0;
    }
  }
  @include e(pattern) {
    width: 105px !important;
  }
  & .sk-icon-remove {
    font-size: $--font-size-large;
    margin-left: 3px;
    cursor: pointer;
  }
  @include e(add) {
    background-color: $--fill-base !important;
    color: $--color-primary !important;
    border: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    line-height: $--font-line-height-base - 0.2em;
    &:hover {
      color: $--color-primary-5 !important;
    }
  }
  & .is-sucess {
    & .el-input__inner {
      border-color: $--color-success !important;
    }
  }
}
</style>
